import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import "./admin.css";
import "./AdminRules.css";

export default function AdminRules() {
  const [sections, setSections] = useState([]);
  const [error, setError] = useState("");

  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editPoints, setEditPoints] = useState("");
  const [editOrder, setEditOrder] = useState(0);

  const [newTitle, setNewTitle] = useState("");
  const [newPoints, setNewPoints] = useState("");
  const [newOrder, setNewOrder] = useState(0);

  const API = process.env.REACT_APP_API_URL;
  const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  const load = async () => {
    try {
      const res = await fetch(`${API}/api/rules`);
      if (!res.ok) {
        setError("Failed to load rules");
        return;
      }
      setSections(await res.json());
    } catch (err) {
      setError("Server error while loading rules");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startEdit = (s) => {
    setEditingId(s.id);
    setEditTitle(s.title);
    setEditPoints(s.points.join("\n"));
    setEditOrder(s.order || 0);
  };

  const cancelEdit = () => setEditingId(null);

  const saveEdit = async (id) => {
    const points = editPoints.split("\n").map((p) => p.trim()).filter(Boolean);
    if (!editTitle || points.length === 0) return;

    await fetch(`${API}/api/rules/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeader },
      body: JSON.stringify({ title: editTitle, points, order: Number(editOrder) }),
    });

    setEditingId(null);
    load();
  };

  const deleteSection = async (id) => {
    await fetch(`${API}/api/rules/${id}`, { method: "DELETE", headers: authHeader });
    load();
  };

  const addSection = async (e) => {
    e.preventDefault();
    const points = newPoints.split("\n").map((p) => p.trim()).filter(Boolean);
    if (!newTitle || points.length === 0) return;

    await fetch(`${API}/api/rules`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader },
      body: JSON.stringify({ title: newTitle, points, order: Number(newOrder) }),
    });

    setNewTitle("");
    setNewPoints("");
    setNewOrder(0);
    load();
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>Manage Rules & SOP</h1>
        <p className="admin-sub">Add, edit, or remove sections shown on the public Rules page</p>

        {error && <p className="admin-error">{error}</p>}

        <form onSubmit={addSection} className="notice-form">
          <label className="notice-label">
            New section title
            <input className="notice-input" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
          </label>
          <label className="notice-label">
            Points (one per line)
            <textarea className="notice-textarea" rows={5} value={newPoints} onChange={(e) => setNewPoints(e.target.value)} />
          </label>
          <label className="notice-label">
            Display order (lower shows first)
            <input type="number" className="notice-input" value={newOrder} onChange={(e) => setNewOrder(e.target.value)} />
          </label>
          <button type="submit" className="approve-btn">Add Section</button>
        </form>

        <div className="rules-admin-list">
          {sections.map((s) => (
            <div className="rules-admin-item" key={s.id}>
              {editingId === s.id ? (
                <>
                  <input className="notice-input rules-admin-title-input" value={editTitle} onChange={(e) => setEditTitle(e.target.value)} />
                  <textarea className="notice-textarea" rows={8} value={editPoints} onChange={(e) => setEditPoints(e.target.value)} />
                  <label className="rules-admin-order-label">
                    Order
                    <input type="number" className="notice-input rules-admin-order-input" value={editOrder} onChange={(e) => setEditOrder(e.target.value)} />
                  </label>
                  <div className="admin-actions">
                    <button className="approve-btn" onClick={() => saveEdit(s.id)}>Save</button>
                    <button className="reject-btn" onClick={cancelEdit}>Cancel</button>
                  </div>
                </>
              ) : (
                <>
                  <div className="rules-admin-header">
                    <strong>{s.title}</strong>
                    <span className="rules-admin-order-badge">order: {s.order}</span>
                    <div className="admin-actions">
                      <button className="approve-btn" onClick={() => startEdit(s)}>Edit</button>
                      <button className="reject-btn" onClick={() => deleteSection(s.id)}>Delete</button>
                    </div>
                  </div>
                  <ul>
                    {s.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          ))}

          {sections.length === 0 && !error && (
            <p className="admin-empty">No rule sections yet</p>
          )}
        </div>
      </div>
    </div>
  );
}